
export default [
  {
    path: '/personal-setting',
    component: resolve => require(['../../views/personalCenter/personalSetting.vue'], resolve),
    meta: {
      title: '个人设置'
    }
  },
  {
    path: '/agreement',
    component: resolve => require(['../../views/personalCenter/agreement.vue'], resolve),
    meta: {
      title: '关于一人E店'
    }
  },
  {
    path: '/login-page-setting',
    component: resolve => require(['../../views/personalCenter/loginPageSetting.vue'], resolve),
    meta: {
      title: '登录页设置'
    }
  },
  {
    path: '/login-page-setting',
    component: resolve => require(['../../views/personalCenter/loginPageSetting.vue'], resolve),
    meta: {
      title: '登录页设置'
    }
  },
  {
    path: '/pay-setting',
    component: resolve => require(['../../views/settings/paySetting.vue'], resolve),
    meta: {
      title: '支付配置'
    }
  },

  // mini-pro-cust-service
  {
    path: '/mini-pro-cust-service',
    component: resolve => require(['../../views/settings/operationSettings/miniProCustService.vue'], resolve),
    meta: {
      title: '小程序客服'
    }
  },
  {
    path: '/settle-method',
    component: resolve => require(['../../views/settings/operationSettings/settlementMethods.vue'], resolve),
    meta: {
      title: '结算方式设置'
    }
  },
  {
    path: '/internal-settle',
    component: resolve => require(['../../views/settings/operationSettings/internalSettlement.vue'], resolve),
    meta: {
      title: '内部结算列表'
    }
  },
  {
    path: '/settle-setting',
    component: resolve => require(['../../views/settings/settledSettings/index.vue'], resolve),
    meta: {
      title: '入驻设置'
    }
  },
  {
    path: '/contract-setting',
    component: resolve => require(['../../views/settings/contractSetting'], resolve),
    meta: {
      title: '合同授权设置'
    }
  },
  {
    path: '/contract-authority-zone',
    component: resolve => require(['../../views/settings/contractAuthorityZone'], resolve),
    meta: {
      title: '合同授权区域管理'
    }
  },
  {
    path: '/contract-list',
    component: resolve => require(['../../views/settings/contractList'], resolve),
    meta: {
      title: '合同列表'
    }
  },
  {
    path: '/contract-account-authority',
    component: resolve => require(['../../views/settings/contractAccountAuthority'], resolve),
    meta: {
      title: '合同授权账号管理'
    }
  },
  {
    path: '/add-contract-template-normal',
    component: resolve => require(['../../../TASMini/views/contract/addContractTemplateNormal'], resolve),
    meta: { title: '新增合同' }
  },
  {
    path: '/shopinfo',
    component: resolve => require(['../../views/settings/shopinfo'], resolve),
    meta: {
      title: '店铺信息'
    }
  },
  {
    path: '/rewardFundSetting',
    component: resolve => require(['../../views/settings/rewardFundSetting'], resolve),
    meta: {
      title: '奖励基金设置'
    }
  },
]



// WEBPACK FOOTER //
// ./src/SRM/router/modules/settings.js